import { Box, Button, Stack } from "@mui/material";
import React from "react";
import Header from "../Components/Header";

export default function CaisseCenter(props) {
    

    return(
        <Box display='flex' flex={1} flexDirection='column' height='100vh'>
            <Header/>

            <Box display='flex' flex={1} flexDirection='column' justifyContent='center'>
                <Stack direction='row' spacing={2} padding={3} alignItems='center' alignSelf='center' sx={{justifySelf:'center'}}>
                    <Button variant="contained" sx={{width:'100px', height:'100px'}} href="">échange</Button>
                    <Button variant="contained" sx={{width:'100px', height:'100px'}} href="">don</Button>
                    <Button variant="contained" sx={{width:'100px', height:'100px'}} href="/caisse/recette">recette</Button>
                    <Button variant="contained" sx={{width:'100px', height:'100px'}} href="">vente d'articles</Button>
                </Stack>
            </Box>
            
        </Box>
    )
}